import { HelpCircleIcon } from '@/components/ui/icons'
import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

import { PageContainer } from '@/components/layout/page-container'
import { ComingSoonCard } from '@/features/account-hub/components/coming-soon-card'

export const Route = createFileRoute('/_app/help')({
  component: HelpPage,
})

function HelpPage(): JSX.Element {
  return (
    <PageContainer>
      <ComingSoonCard
        icon={<HelpCircleIcon />}
        title="Centro de ayuda"
        description="Pronto tendrás acceso a guías, tutoriales y respuestas a las preguntas más frecuentes sobre Abakoo."
      />
    </PageContainer>
  )
}
